import {NgModule} from '@angular/core';
import {CommonModule} from "@angular/common";
import {ButtonModule} from "primeng/primeng";
import {UIBaseModule} from "@catui/ui-base.module";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {UIFormModule} from "@catuiform/ui-form.module";
import {FeatureParameterFormComponent} from "@catmodels/feature-parameter/components/feature-parameter-form/feature-parameter-form.component";
import {FeatureParameterLandingComponent} from "@catmodels/feature-parameter/components/feature-parameter-landing/feature-parameter-landing.component";
import {ParametersModule} from "@catmodels/parameters/parameters.module";

const publicComponents = [
  FeatureParameterFormComponent,
  FeatureParameterLandingComponent
];

const imports = [
  CommonModule,
  UIBaseModule,
  ButtonModule,
  FormsModule,
  UIFormModule,
  ReactiveFormsModule,
  ParametersModule
];
const declarations = [
  ...publicComponents,
];

const exportings = [...publicComponents];

const providers = [];
const entryComponents = [...publicComponents];

@NgModule({
  declarations,
  entryComponents,
  exports: exportings,
  imports,
  providers,
})
export class FeatureParameterModule {
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-parameter/feature-parameter.module.ts